import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { aboutRewardAPI } from '../../services/api';

interface AboutRewardState {
  content: string;
  loading: boolean;
  error: string | null;
  saved: boolean;
}

const initialState: AboutRewardState = {
  content: '',
  loading: false,
  error: null,
  saved: false,
};

export const fetchAboutUs = createAsyncThunk(
  'aboutReward/fetchAboutUs',
  async () => {
    const response = await aboutRewardAPI.getAboutUs();
    console.log('Fetched about us content:', response);
    return response.data.text;
  }
);

// Async thunk for saving about us content
export const saveAboutUs = createAsyncThunk(
  'aboutReward/saveAboutUs',
  async (content: string) => {
    const response = await aboutRewardAPI.updateAboutUs(content);
    return response.data.text;
  }
);

const aboutUsSlice = createSlice({
  name: 'aboutUs',
  initialState,
  reducers: {
    setContent: (state, action: PayloadAction<string>) => {
      state.content = action.payload;
    },
    clearSaved: (state) => {
      state.saved = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAboutUs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAboutUs.fulfilled, (state, action) => {
        state.loading = false;
        state.content = action.payload;
      })
      .addCase(fetchAboutUs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch About Us';
      })
      .addCase(saveAboutUs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveAboutUs.fulfilled, (state, action) => {
        state.loading = false;
        state.content = action.payload;
        state.saved = true;
      })
      .addCase(saveAboutUs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to save About Us';
      });
  },
});

export const { setContent, clearSaved, clearError } = aboutUsSlice.actions;
export default aboutUsSlice.reducer;

